import React, { useEffect, useState, useRef } from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import Modal from '../components/Modal';
import Swal from 'sweetalert2';
import "../scss/card.css"
import { CButton, CModal, CModalHeader, CModalTitle, CModalBody, CModalFooter } from '@coreui/react';
import { generateAxiosInstance } from '../hooks/useAuthorizedRequest';
import { generateAxiosInstanceCommonFileUpload } from '../hooks/useAuthorizedRequestForFileUpload';
import { generateAxiosInstanceCommon } from '../hooks/useAuthorizedReuestCommon';
import { useNavigate } from 'react-router-dom';
import Pagination from '../components/Pagination';
import { findIndexById, findPageNumber, deleteItem, SortIcon, searchArray } from '../components/Navigation';
import { getLink, validateQuestionData, handleQuestionUpdate, handleSelectAll, isErrorQuestion, SolutionModal, ImageModal, Loader } from '../components/ModalsCommonFunctions';
import ViewImageAndText from '../components/ViewImageAndText';

const CompetitiveUploadQuestionBank = () => {
    const authorizedAxios = generateAxiosInstance();
    const authorizedAxiosCommon = generateAxiosInstanceCommon();
    const authorizedAxiosCommonFileUpload = generateAxiosInstanceCommonFileUpload();

    const initialFormState = {
        competitiveExamNameMasterId: '',
        competitiveLessonMasterId: '',
        competitiveTopicMasterId: '',
        competitiveExamBookMasterId: '',
        subjectMasterId: '',
        competitiveSubTopicMasterId: '',
        importFile: '',
        questionData: []
    }
    const [syllabusList, setSyllabusList] = useState([])
    const [lessonList, setLessonList] = useState([])
    const [topicList, setTopicList] = useState([])
    const [subtopicList, setSubtopicList] = useState([])
    const [subtopicListName, setSubtopicListName] = useState([])

    const [subtopicData, setSubtopicData] = useState(initialFormState)
    const [editId, setEditId] = useState(null)
    const [bookList, setBookList] = useState([])
    const [subjectList, setSubjectList] = useState([])
    const [inputpdf, setInputPdf] = useState({ value: '' })
    const [errorQuestions, setErrorQuestions] = useState({})
    const [questionList, setQuestionList] = useState([])
    const [modalImageSrc, setModalImageSrc] = useState('');
    const [visibleImage, setVisibleImage] = useState(false);
    const [modalData, setModalData] = useState("")
    const [visible, setVisible] = useState(false)
    const [visibleSolution, setVisibleSolution] = useState(false);

    const [showPdfLink, setShowPdfLink] = useState([])
    const [selectedGrade, setSelectedGrade] = useState()
    const [selectedDivision, setSelectedDivision] = useState()
    const [jsonPars, setJasonParse] = useState([])
    const [text, setText] = useState('')
    const [showPdfLinkdataType, setShowPdfLikDateType] = useState()

    const inputFile = useRef(null);

    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);
    const [refresh, setRefresh] = useState(true);
    const [addNew, setAddNew] = useState(false);

    const [examSort, setExamSort] = useState(null);
    const [bookSort, setBookSort] = useState(null);
    const [subjectSort, setSubjectSort] = useState(null);
    const [lessonSort, setLessonSort] = useState(null);
    const [topicSort, setTopicSort] = useState(null);
    const [subtopicSort, setSubtopicSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["competitiveExamNameMasterDetails.examName", "competitiveExamBookMasterDetails.bookName", "subjectMasterDetails.subjectName", "competitiveLessonMasterDetails.competitiveLessonName", "competitiveTopicMasterDetails.competitiveTopicName", "competitiveSubTopicMasterDetails.competitiveSubTopicName"];

    //error
    const initialErrorState = {

    }
    const [error, setError] = useState(initialErrorState)
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleNavigate = (route) => {
        navigate(route);
    };

    const onViewImage = (imgSrc) => {
        setModalImageSrc(imgSrc);
        setVisibleImage(true);
    };

    useEffect(() => {
        getSyllabusList();
    }, []);

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            setRefresh(!refresh);
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const getApiUrl = () => {
        if (subtopicData.competitiveExamNameMasterId !== '' && subtopicData.competitiveExamBookMasterId !== '' && subtopicData.subjectMasterId !== '') {
            let apiUrl = '/get-competitive-question-bank-import-log?';

            if (subtopicData.competitiveExamNameMasterId) {
                apiUrl += `competitiveExamNameMasterId=${subtopicData.competitiveExamNameMasterId}&`;
            }

            if (subtopicData.competitiveExamBookMasterId) {
                apiUrl += `competitiveExamBookMasterId=${subtopicData.competitiveExamBookMasterId}&`
            }

            if (subtopicData.competitiveLessonMasterId) {
                apiUrl += `competitiveLessonMasterId=${subtopicData.competitiveLessonMasterId}&`;
            }

            if (subtopicData.competitiveTopicMasterId) {
                apiUrl += `competitiveTopicMasterId=${subtopicData.competitiveTopicMasterId}&`;
            }
            if (subtopicData.competitiveSubTopicMasterId) {
                apiUrl += `competitiveSubTopicMasterId=${subtopicData.competitiveSubTopicMasterId}&`;
            }
            if (subtopicData.subjectMasterId) {
                apiUrl += `subjectMasterId=${subtopicData.subjectMasterId}&`;
            }

            apiUrl = apiUrl.replace(/&$/, '');
            return apiUrl;
        }
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            if (subtopicData.competitiveExamNameMasterId !== '' && subtopicData.competitiveExamBookMasterId !== '' && subtopicData.subjectMasterId !== '') {
                setSubtopicList(await searchArray("A", getApiUrl(), searchKeys, searchValue.trim(), "data"))
            }
        }
    }

    useEffect(() => {
        if (subtopicData.competitiveExamNameMasterId !== '' && subtopicData.competitiveExamBookMasterId !== '' && subtopicData.subjectMasterId !== '') {
            let apiUrl = getApiUrl();

            authorizedAxios && authorizedAxios.get(apiUrl)
                .then(response => {
                    setSubtopicList(response.data.data);
                    // console.log('Data:', response.data);
                })
                .catch(error => {
                    setSubtopicList([]);
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.error('Error fetching data:', errorMsg);
                });
        }
    }, [subtopicData, refresh]);

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(subtopicList, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId, addNew])

    useEffect(() => {
        setTotalPages(Math.ceil(subtopicList.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > subtopicList.length) {
            endIndex = subtopicList.length;
        }
        setDisplayedData(subtopicList.slice(startIndex, endIndex));
    }, [subtopicList, currPage, itemsPerPage]);

    const getUploadedList = () => {
        if (subtopicData.competitiveExamNameMasterId !== '' && subtopicData.competitiveExamBookMasterId !== '' && subtopicData.subjectMasterId !== '') {
            let apiUrl = getApiUrl();
            // const apiUrl = `/get-topic-master-list`;
            authorizedAxios && authorizedAxios.get(apiUrl)
                .then(response => {
                    setSubtopicList(response.data.data);
                    setAddNew(!addNew);
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    Swal.fire({
                        text: errorMsg
                    })
                });
        }
    }

    const getSyllabusList = () => {
        const apiUrlForSyllabus = `/get-competitive-exam-names`;
        authorizedAxios && authorizedAxios.get(apiUrlForSyllabus)
            .then(response => {
                setSyllabusList(response.data.result)
                // console.log('Data:', response.data);
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleInputChange = (e) => {
        setSubtopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value
            }
        })
    }

    const handleSyllabusChange = (e) => {
        setSubtopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                subjectMasterId: '',
                competitiveExamBookMasterId: '',
                competitiveLessonMasterId: '',
                competitiveTopicMasterId: ''
            }
        })

        const apiUrl2 = `/get-competitive-exam-book-master?competitiveExamNameMasterId=${e.target.value}`;
        authorizedAxios && authorizedAxios.get(apiUrl2)
            .then(response => {
                setBookList(response.data.data)
                console.log('Data:', response.data);
            })
            .catch(error => {
                // Handle any errors that occurred during the request
                console.error('Error fetching data:', error);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';

            });
    }

    const handleBookChanges = (e) => {
        setSubtopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                subjectMasterId: '',
                competitiveLessonMasterId: '',
                competitiveTopicMasterId: ''
            }
        })

        const apiUrl2 = `/get-competitive-exam-book-wise-subject?competitiveExamBookMasterId=${e.target.value}`;
        authorizedAxios && authorizedAxios.get(apiUrl2)
            .then(response => {
                setSubjectList(response.data.result)
                // console.log('Data:', response.data);
            })
            .catch(error => {
                // Handle any errors that occurred during the request
                console.error('Error fetching data:', error);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';

            });

    }

    const handleSubjectChanges = (e) => {
        setSubtopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                competitiveTopicMasterId: '',
                competitiveSubTopicMasterId: ''


            }
        })

        const apiUrl = `/get-competitive-lesson?competitiveExamBookMasterId=${subtopicData.competitiveExamBookMasterId}&subjectMasterId=${e.target.value}`;
        authorizedAxios && authorizedAxios.get(apiUrl)
            .then(response => {
                setLessonList(response.data.result)
                console.log('Data:', response.data);
            })
            .catch(error => {
                // Handle any errors that occurred during the request
                setLessonList(error?.response?.data.result);

                console.error('Error fetching data:', error);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';

            });
    }

    const handleLessonChange = (e) => {
        setSubtopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                competitiveTopicMasterId: '',
                competitiveSubTopicMasterId: ''
            }
        })
        const apiUrl = `/get-competitive-topic?competitiveLessonMasterId=${e.target.value}`;
        authorizedAxios && authorizedAxios.get(apiUrl)
            .then(response => {
                setTopicList(response.data.result)
                // console.log('Data:', response.data);
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleTopicChange = (e) => {
        setSubtopicData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                competitiveSubTopicMasterId: ''
            }
        })
        const apiUrl = `/get-competitive-sub-topic?competitiveExamNameMasterId=${subtopicData.competitiveExamNameMasterId}&competitiveExamBookMasterId=${subtopicData.competitiveExamBookMasterId}&competitiveLessonMasterId=${subtopicData.competitiveLessonMasterId}&competitiveTopicMasterId=${e.target.value}`;
        authorizedAxios && authorizedAxios.get(apiUrl)
            .then(response => {
                setSubtopicListName(response.data.result)
                // console.log('Data:', response.data);
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleUploadLogo = async (e) => {
        const file = e.target.files[0];
        const fileExtension = file.name.split(".").pop().toLowerCase();
        const body = new FormData();
        body.append("file", file);
        setInputPdf(e.target);

        if (fileExtension === "xlsx" || fileExtension === "docx") {
            setLoading(true); // Start loading indicator

            try {
                const link = await getLink(e.target.name, body, setSubtopicData);
                if (!link) throw new Error('Link not generated');

                const endpoint = fileExtension === "docx"
                    ? "convert-question-bank-docx"
                    : "convert-question-bank-xlsx-v2";
                const payload = fileExtension === "docx"
                    ? { "wordFilePath": link }
                    : { "excelFilePath": link };

                const response = await authorizedAxiosCommon.post(endpoint, payload);
                setErrorQuestions(validateQuestionData(response.data.convertedData, true, setQuestionList));
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
                Swal.fire({ text: errorMsg });
            } finally {
                setLoading(false); // Stop loading indicator
            }
        } else {
            e.target.value = '';
            Swal.fire({ text: "Only xlsx and docx files are supported" });
        }
    };

    const validateForm = () => {
        const subtopicDataValid = Object.entries(subtopicData).every(([key, value]) => {
            if (key !== 'competitiveTopicMasterId' && key !== 'competitiveSubTopicMasterId') {
                if (typeof value === 'string') {
                    if (value === '') {
                        return false;
                    }
                }
            }
            return true;
        });

        const isQuestionDataNotEmpty = subtopicData.questionData.length > 0;

        if (subtopicData.importFile !== '') {
            if (!isQuestionDataNotEmpty) {
                return false;
            }
        }

        return subtopicDataValid;
    };

    useEffect(() => {
        if (!Object.values(error).every(error => error === '')) {
            const newErrors = {};

            // Validate each field in subtopicData
            for (const [key, value] of Object.entries(subtopicData)) {
                if (key !== 'competitiveTopicMasterId' && key !== 'competitiveSubTopicMasterId') {
                    if (typeof value === 'string' && value.trim() === '') {
                        newErrors[key] = 'This field is required.';
                    } else {
                        newErrors[key] = ''; // Clear error if field is valid
                    }
                }
            }

            const isQuestionDataNotEmpty = subtopicData.questionData.length > 0;

            if (subtopicData.importFile !== '' && subtopicData.importFile !== 0) {
                if (!isQuestionDataNotEmpty) {
                    newErrors['questionData'] = 'At least one question is required.';
                } else {
                    newErrors['questionData'] = '';
                }
            }

            setError(newErrors);
        }
    }, [subtopicData]);

    const callQuestionBankSaveApi = (apiUrl, modifiedSubtopicData) => {
        return authorizedAxios && authorizedAxios.post(apiUrl, modifiedSubtopicData)
            .then(response => {
                getUploadedList();
                setSubtopicData((prevData) => {
                    return {
                        ...prevData,
                        importFile: '',
                        questionData: []
                    }
                })
                inputFile.current.value = '';
                setQuestionList([]);
                setErrorQuestions({});
                setExamSort(null);
                setBookSort(null);
                setSubjectSort(null);
                setLessonSort(null);
                setTopicSort(null);
                setSubtopicSort(null);
                Swal.fire(
                    { text: response.data.message }
                );
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            });
    }

    // const addTopic = () => {
    //     if (validateForm()) {
    //         const modifiedSubtopicData = {
    //             ...subtopicData,
    //             competitiveTopicMasterId: subtopicData.competitiveTopicMasterId?.trim() === '' ? null : subtopicData?.competitiveTopicMasterId,
    //             competitiveSubTopicMasterId: subtopicData.competitiveSubTopicMasterId?.trim() === '' ? null : subtopicData?.competitiveSubTopicMasterId
    //         };
    //         const fileExtension = subtopicData.importFile.split('.').pop().toLowerCase();

    //         delete modifiedSubtopicData.importFile;
    //         const questionIds = validateQuestionData(subtopicData.questionData, false);
    //         if (fileExtension === "docx") {
    //             const apiUrl = '/import-competitive-question-bank-docx';

    //             if (questionIds.errorCount > 0) {
    //                 const matchedQuestionIndices = questionIds.errorquestionIds.map(id => {
    //                     const index = questionList.findIndex(question => question.no === id);
    //                     return index !== -1 ? (index + 1).toString() : null;
    //                 }).filter(index => index !== null).join(', ');

    //                 const message = `Errors found in questions at indices: ${matchedQuestionIndices}`;

    //                 Swal.fire({
    //                     text: message
    //                 });
    //                 return;
    //             }

    //             callQuestionBankSaveApi(apiUrl, modifiedSubtopicData);
    //         } else if (fileExtension === "xlsx") {
    //             const apiUrl = `/import-competitive-question-bank-xlsx`;

    //             if (questionIds.errorCount > 0) {
    //                 const matchedQuestionIndices = questionIds.errorquestionIds.map(id => {
    //                     const index = questionList.findIndex(question => question.no === id);
    //                     return index !== -1 ? (index + 1).toString() : null;
    //                 }).filter(index => index !== null).join(', ');

    //                 const message = `Errors found in questions at indices: ${matchedQuestionIndices}`;

    //                 Swal.fire({
    //                     text: message
    //                 });
    //                 return;
    //             }

    //             callQuestionBankSaveApi(apiUrl, modifiedSubtopicData);
    //         }
    //     } else {
    //         const newErrors = {};

    //         for (const [key, value] of Object.entries(subtopicData)) {
    //             if (key !== 'competitiveTopicMasterId' && key !== 'competitiveSubTopicMasterId') {
    //                 if (typeof value === 'string' && value.trim() === '') {
    //                     newErrors[key] = 'This field is required.';
    //                 } else {
    //                     newErrors[key] = ''; // Clear error if field is valid
    //                 }
    //             }
    //         }

    //         const isQuestionDataNotEmpty = subtopicData.questionData.length > 0;

    //         if (subtopicData.importFile !== '' && !isQuestionDataNotEmpty) {
    //             newErrors['questionData'] = 'At least one question is required.';
    //         } else {
    //             newErrors['questionData'] = '';
    //         }

    //         setError(newErrors);
    //     }
    // }

    const addTopic = () => {
        if (!validateForm()) {
            handleFormErrors();
            setLoading(false);
            return;
        }
    
        setLoading(true);
        const modifiedSubtopicData = {
            ...subtopicData,
            competitiveTopicMasterId: subtopicData.competitiveTopicMasterId?.trim() === '' ? null : subtopicData?.competitiveTopicMasterId,
            competitiveSubTopicMasterId: subtopicData.competitiveSubTopicMasterId?.trim() === '' ? null : subtopicData?.competitiveSubTopicMasterId
        };
    
        const fileExtension = subtopicData.importFile.split('.').pop().toLowerCase();
        delete modifiedSubtopicData.importFile;
    
        const questionIds = validateQuestionData(subtopicData.questionData, false);
        if (questionIds.errorCount > 0) {
            handleQuestionErrors(questionIds.errorquestionIds);
            setLoading(false);
            return;
        }
    
        const apiUrl = fileExtension === "docx" 
            ? '/import-competitive-question-bank-docx'
            : '/import-competitive-question-bank-xlsx';
    
        callQuestionBankSaveApi(apiUrl, modifiedSubtopicData)
            .finally(() => {
                setLoading(false); // End loading
            });
    };

    const handleFormErrors = () => {
        const newErrors = {};
    
        for (const [key, value] of Object.entries(subtopicData)) {
            if (key !== 'competitiveTopicMasterId' && key !== 'competitiveSubTopicMasterId') {
                newErrors[key] = typeof value === 'string' && value.trim() === '' ? 'This field is required.' : '';
            }
        }
    
        if (subtopicData.importFile !== '' && subtopicData.questionData.length === 0) {
            newErrors['questionData'] = 'At least one question is required.';
        } else {
            newErrors['questionData'] = '';
        }
    
        setError(newErrors);
    };

    const handleQuestionErrors = (errorQuestionIds) => {
        const matchedQuestionIndices = errorQuestionIds
            .map(id => {
                const index = questionList.findIndex(question => question.no === id);
                return index !== -1 ? (index + 1).toString() : null;
            })
            .filter(index => index !== null)
            .join(', ');
    
        const message = `Errors found in questions at indices: ${matchedQuestionIndices}`;
    
        Swal.fire({ text: message });
    };

    const reset = () => {
        setSubtopicData(initialFormState);
        setSubtopicList([]);
        setEditId('');
        inputpdf.value = "";
        inputFile.current.value = '';
        setSubtopicList([]);
        setQuestionList([]);
        setErrorQuestions({});
        setModalImageSrc('');
        setVisibleImage(false);
        setModalData("");
        setVisibleSolution(false);
        setDisplayedData([]);
        setError(initialErrorState);
    }

    const deleteSubtopic = (id) => {
        let confirmed = window.confirm('Are you sure? you want to delete this record.');
        if (confirmed) {
            const apiUrl = `/delete-competitive-sub-topic?id=${id}`;
            authorizedAxios && authorizedAxios.delete(apiUrl)
                .then(response => {
                    // setSubtopicList((prevSubtopicList) => [...prevSubtopicList].filter((subtopic) => subtopic.id !== id))
                    const page = deleteItem(currPage, itemsPerPage, subtopicList.length);
                    setRefresh(!refresh);
                    setCurrPage(page);

                    Swal.fire(
                        { text: response.data.message }
                    );
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    Swal.fire(
                        { text: errorMsg }
                    );
                });
        }
    }

    const updateSubtopic = () => {
        const apiUrl = `/edit-competitive-sub-topic?id=${editId}`;
        authorizedAxios && authorizedAxios.put(apiUrl, subtopicData)
            .then(response => {
                getUploadedList();
                setSaveId(response.data.result.id);
                setEditId(null);
                setSubtopicData((prevData) => {
                    return {
                        ...prevData,
                    }
                })
                Swal.fire(
                    { text: response.data.message }
                );
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            });
    }

    function uploadAdapter(loader) {
        return {
            upload: () => {
                return new Promise((resolve, reject) => {
                    const body = new FormData();
                    loader.file.then(async (file) => {
                        body.append("file", file);
                        const apiUrl = "uploadimage";
                        authorizedAxiosCommonFileUpload && authorizedAxiosCommonFileUpload.post(apiUrl, body)
                            .then((res) => {
                                resolve({ default: res.data.url });
                            })
                            .catch((err) => {
                                reject(err);
                            });
                    });
                });
            },
        };
    }

    function uploadPlugin(editor) {
        editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
            return uploadAdapter(loader);
        };
    }

    useEffect(() => {
        if (showPdfLink !== null) {
            if (showPdfLink.indexOf('[') >= 0) {
                setShowPdfLikDateType("array")
                setJasonParse(JSON.parse(showPdfLink))
            } else {
                setShowPdfLikDateType("string")
                setText(showPdfLink)
            }
        } else {
            setShowPdfLikDateType("string")
            setText(showPdfLink)
        }
    }, [showPdfLink])

    const getFileName = (path) => {
        let i = path?.length - 1;
        let name = "";
        while (i >= 0 && path[i] !== "/") {
            name = path[i] + name;
            i--;
        }

        return name;
    }

    useEffect(() => {
        if (examSort == true || examSort == false) {
            setBookSort(null);
            setSubjectSort(null);
            setLessonSort(null);
            setTopicSort(null);
            setSubtopicSort(null);
        }
    }, [examSort])

    useEffect(() => {
        if (bookSort == true || bookSort == false) {
            setExamSort(null);
            setSubjectSort(null);
            setLessonSort(null);
            setTopicSort(null);
            setSubtopicSort(null);
        }
    }, [bookSort])

    useEffect(() => {
        if (subjectSort == true || subjectSort == false) {
            setExamSort(null);
            setBookSort(null);
            setLessonSort(null);
            setTopicSort(null);
            setSubtopicSort(null);
        }
    }, [subjectSort])

    useEffect(() => {
        if (lessonSort == true || lessonSort == false) {
            setExamSort(null);
            setBookSort(null);
            setSubjectSort(null);
            setTopicSort(null);
            setSubtopicSort(null);
        }
    }, [lessonSort])

    useEffect(() => {
        if (topicSort == true || topicSort == false) {
            setExamSort(null);
            setBookSort(null);
            setSubjectSort(null);
            setLessonSort(null);
            setSubtopicSort(null);
        }
    }, [topicSort])

    useEffect(() => {
        if (subtopicSort == true || subtopicSort == false) {
            setExamSort(null);
            setBookSort(null);
            setSubjectSort(null);
            setLessonSort(null);
            setTopicSort(null);
        }
    }, [topicSort])

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>Competitive Exam Upload</span></li>
                        </ol>
                    </nav>
                </div>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-file-circle-check"></i> Competitive Exam Upload</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Competitive Exam Name :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='competitiveExamNameMasterId' onChange={handleSyllabusChange} value={subtopicData.competitiveExamNameMasterId}>
                                                        <option selected value={''} disabled>Select Competitive Exam  Structure</option>
                                                        {
                                                            syllabusList?.map((syllabus) => {
                                                                return <option value={syllabus.id}>{syllabus?.examName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.competitiveExamNameMasterId && <p style={{ color: 'red' }}>{error.competitiveExamNameMasterId}</p>}

                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Book :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='competitiveExamBookMasterId' onChange={handleBookChanges} value={subtopicData.competitiveExamBookMasterId}>
                                                        <option selected value={''} disabled>Select Book</option>
                                                        {
                                                            bookList?.map((syllabus) => {
                                                                return <option value={syllabus.id}>{syllabus.bookName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.competitiveExamBookMasterId && <p style={{ color: 'red' }}>{error.competitiveExamBookMasterId}</p>}

                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Subject :</label>
                                                    <select class="form-select" aria-label="Default select example" name='subjectMasterId' onChange={handleSubjectChanges} value={subtopicData.subjectMasterId}>
                                                        <option selected value={''} disabled>Select Subject</option>
                                                        {
                                                            subjectList?.map((syllabus) => {
                                                                return <option value={syllabus.subjectMasterDetails.id}>{syllabus.subjectMasterDetails.subjectName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.subjectMasterId && <p style={{ color: 'red' }}>{error.subjectMasterId}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Lesson :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='competitiveLessonMasterId' onChange={handleLessonChange} value={subtopicData.competitiveLessonMasterId}>
                                                        <option selected value={''} disabled>Select Lesson</option>
                                                        {
                                                            lessonList?.map((lesson) => {
                                                                return <option value={lesson.id}>{lesson.competitiveLessonName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.competitiveLessonMasterId && <p style={{ color: 'red' }}>{error.competitiveLessonMasterId}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Select Topic :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='competitiveTopicMasterId' onChange={handleTopicChange} value={subtopicData.competitiveTopicMasterId}>
                                                        <option selected value={''} disabled>Select Topic</option>
                                                        {
                                                            topicList?.map((topic) => {
                                                                return <option value={topic.id}>{topic.competitiveTopicName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.competitiveTopicMasterId && <p style={{ color: 'red' }}>{error.competitiveTopicMasterId}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Select Sub Topic :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='competitiveSubTopicMasterId' onChange={handleInputChange} value={subtopicData.competitiveSubTopicMasterId}>
                                                        <option selected value={''} disabled>Select Sub Topic</option>
                                                        {
                                                            subtopicListName?.map((subtopic) => {
                                                                return <option value={subtopic.id}>{subtopic.competitiveSubTopicName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.competitiveTopicMasterId && <p style={{ color: 'red' }}>{error.competitiveTopicMasterId}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Upload Competitive Question Bank :</label>
                                                    <label style={{ color: "red" }} >only xlsx & docx file supported</label>
                                                    <input required type="file" className="form-control" name="importFile" onChange={handleUploadLogo} ref={inputFile} />
                                                    <a download href='https://api.examninja.co.in/files/question-bank-import-ex.xlsx'>Sample xlsx file</a>&nbsp;
                                                    <a download href='https://api.examninja.co.in/files/SampleDoc.docx'>Sample docx file</a>
                                                    {error.importFile && <p style={{ color: 'red' }}>{error.importFile}</p>}
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>

                                                    <div className="col-auto">
                                                        <button className="btn btn-primary" type="button" style={{ marginRight: '20px' }} onClick={addTopic}>Save</button>
                                                        <button className="btn btn-outline-danger delete_icon" type="button" style={{ marginRight: '20px' }} onClick={reset}>Reset</button>
                                                        {/* {
                                                            editId && (<button className="btn btn-success approve_icon" type="button" onClick={updateSubtopic} disabled={!editId}>Update</button>)
                                                        } */}
                                                    </div>
                                                </div>

                                                <CModal
                                                    visible={visible}
                                                    onClose={() => setVisible(false)}
                                                    aria-labelledby="LiveDemoExampleLabel"
                                                >
                                                    <div className="book book-modal">
                                                        <div className='table-header-like'>  {selectedGrade} - {selectedDivision}</div>
                                                        <div style={{ overflowY: "scroll", }} className='page' >
                                                            <div>
                                                                {
                                                                    showPdfLinkdataType == "array" ?
                                                                        <table class="table">
                                                                            <thead>
                                                                                <tr>
                                                                                    <th scope="col" className='sl_no'>Sr. No.</th>
                                                                                    <th scope="col">Name </th>
                                                                                    <th scope="col">Purpose </th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {
                                                                                    jsonPars.map((lesson, index) => {
                                                                                        return (
                                                                                            <tr>
                                                                                                <th scope="row" className='sl_no'>{index + 1}</th>
                                                                                                <td>{lesson.record[2]}</td>
                                                                                                <td>{lesson.purpose}</td>
                                                                                            </tr>
                                                                                        )
                                                                                    })
                                                                                }
                                                                            </tbody>
                                                                        </table>
                                                                        :
                                                                        <div className='no-error-class'>{text ? text : "No error found"}</div>
                                                                }
                                                            </div>
                                                        </div>
                                                        <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => setVisible(false)}>
                                                            Close
                                                        </button>
                                                    </div>
                                                </CModal>

                                                {visibleSolution && <SolutionModal visibleSolution={visibleSolution} setVisibleSolution={setVisibleSolution} modalData={modalData} />}

                                                {visibleImage && <ImageModal visibleImage={visibleImage} setVisibleImage={setVisibleImage} modalImageSrc={modalImageSrc} />}

                                                {/* {questionList.length === 0 && <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col">Uploaded Files </th>
                                                                        <th scope="col">Total Question Count</th>
                                                                        <th scope="col">Imported Question Count</th>
                                                                        <th scope="col">
                                                                            Exam
                                                                            <SortIcon sortState={examSort} setSortState={setExamSort} setData={setSubtopicList} setCurrPage={setCurrPage} sortingPath={"competitiveExamNameMasterDetails.examName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Book
                                                                            <SortIcon sortState={bookSort} setSortState={setBookSort} setData={setSubtopicList} setCurrPage={setCurrPage} sortingPath={"competitiveExamBookMasterDetails.bookName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Subject
                                                                            <SortIcon sortState={topicSort} setSortState={setTopicSort} setData={setSubtopicList} setCurrPage={setCurrPage} sortingPath={"subjectMasterDetails.subjectName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Lesson
                                                                            <SortIcon sortState={lessonSort} setSortState={setLessonSort} setData={setSubtopicList} setCurrPage={setCurrPage} sortingPath={"competitiveLessonMasterDetails.competitiveLessonName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Topic
                                                                            <SortIcon sortState={topicSort} setSortState={setTopicSort} setData={setSubtopicList} setCurrPage={setCurrPage} sortingPath={"competitiveTopicMasterDetails.competitiveTopicName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Sub Topic
                                                                            <SortIcon sortState={subtopicSort} setSortState={setSubtopicSort} setData={setSubtopicList} setCurrPage={setCurrPage} sortingPath={"competitiveSubTopicMasterDetails.competitiveSubTopicName"} />
                                                                        </th>
                                                                        <th scope="col">Note</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData?.length > 0 ?
                                                                            displayedData.map((lesson, index) => {
                                                                                return (
                                                                                    <tr className={lesson.importStatus == "IMPORTED" ? 'greenTable' : lesson.importStatus == "FAILED" ? "redTable" : lesson.importStatus == "NOT STARTED" ? "yellowTable" : "yellowTable"}>
                                                                                        <td>{getFileName(lesson?.localFilePath)}<a href={lesson.localFilePath} download style={{ textDecoration: "none" }}><i class="fa-solid fa-download"></i></a></td>
                                                                                        <td>{lesson.importedQuestionCount}</td>
                                                                                        <td>{lesson.importedQuestionCount}</td>
                                                                                        <td>{lesson?.competitiveExamNameMasterDetails?.examName}</td>
                                                                                        <td>{lesson?.competitiveExamBookMasterDetails?.bookName}</td>
                                                                                        <td>{lesson?.subjectMasterDetails?.subjectName}</td>
                                                                                        <td>{lesson?.competitiveLessonMasterDetails?.competitiveLessonName}</td>
                                                                                        <td>{lesson?.competitiveTopicMasterDetails?.competitiveTopicName}</td>
                                                                                        <td>{lesson?.competitiveSubTopicMasterDetails?.competitiveSubTopicName}</td>
                                                                                        <td>
                                                                                            <button className="btn btn-primary view_icon" type="button" onClick={() => {
                                                                                                setShowPdfLink(lesson.note)
                                                                                                setVisible(true)
                                                                                                setSelectedGrade(lesson?.competitiveExamNameMasterDetails?.examName)
                                                                                                setSelectedDivision(lesson?.competitiveExamBookMasterDetails?.bookName)
                                                                                            }}><i class="fa fa-eye" ></i> Error</button>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Student Available</th>

                                                                            </tr>)
                                                                    }
                                                                </tbody>
                                                            </table>

                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={subtopicList.length} />

                                                        </div>
                                                    </div>
                                                </div>} */}

                                                {questionList.length !== 0 && <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-pane p-3 active prefilter" role="tabpanel" id="prefilter-1000">
                                                        {/* {questions.length > 0 && <ErrorMessage errors={errors} field="question_ids" />} */}
                                                        <div>
                                                            {errorQuestions.errorCount > 0 && (
                                                                <div className="alert alert-danger" role="alert">
                                                                    {errorQuestions.errorCount === 1 ?
                                                                        `There is ${errorQuestions.errorCount} invalid or empty question` :
                                                                        `There are ${errorQuestions.errorCount} invalid or empty questions`
                                                                    }
                                                                </div>
                                                            )}
                                                        </div>
                                                        {error.questionData && <p style={{ color: 'red' }}>{error.questionData}</p>}
                                                        <table class="table">
                                                            <thead>
                                                                <tr>
                                                                    {questionList?.length > 0 && <th>
                                                                        <input
                                                                            type='checkbox'
                                                                            checked={subtopicData.questionData.length === questionList.length}
                                                                            onClick={() => handleSelectAll(questionList, subtopicData, setSubtopicData)}
                                                                        /> All
                                                                    </th>}
                                                                    <th scope="col" className='sl_no'>Sr. No.</th>
                                                                    <th scope='col'>Q_Level</th>
                                                                    <th scope='col'>Q_Type</th>
                                                                    <th scope='col'>Question</th>
                                                                    <th scope="col">Option_a</th>
                                                                    <th scope="col">Option_b </th>
                                                                    <th scope="col">Option_c</th>
                                                                    <th scope="col">Option_d</th>
                                                                    <th scope='col'>Answer</th>
                                                                    <th scope='col'>Solution</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    questionList?.length > 0 ?
                                                                        questionList?.map((question, index) => {
                                                                            const rowClass = isErrorQuestion(errorQuestions, question) ? 'error-row' : '';

                                                                            return (
                                                                                <tr key={index} className={rowClass}>
                                                                                    <td><input type='checkbox' checked={subtopicData.questionData.some(q => q.no === question.no)} onChange={() => handleQuestionUpdate(question, subtopicData, setSubtopicData)} /></td>
                                                                                    <th scope="row" className='sl_no'>{index + 1}</th>
                                                                                    {question.q_level ? <td>{question.q_level}</td> : <td>E</td>}
                                                                                    {question.q_type ? <td>{question.q_type}</td> : <td>S</td>}
                                                                                    {/* <td><ViewImageAndText inputString={question.question} onViewImage={onViewImage} /></td>
                                                                                    <td><ViewImageAndText inputString={question.options['a)']} onViewImage={onViewImage} /></td>
                                                                                    <td><ViewImageAndText inputString={question.options['b)']} onViewImage={onViewImage} /></td>
                                                                                    <td><ViewImageAndText inputString={question.options['c)']} onViewImage={onViewImage} /></td>
                                                                                    <td><ViewImageAndText inputString={question.options['d)']} onViewImage={onViewImage} /></td> */}
                                                                                    <td><div dangerouslySetInnerHTML={{ __html: question.question }} /></td>
                                                                                    <td><div dangerouslySetInnerHTML={{ __html: question.options['a)'] }} /></td>
                                                                                    <td><div dangerouslySetInnerHTML={{ __html: question.options['b)'] }} /></td>
                                                                                    <td><div dangerouslySetInnerHTML={{ __html: question.options['c)'] }} /></td>
                                                                                    <td><div dangerouslySetInnerHTML={{ __html: question.options['d)'] }} /></td>
                                                                                    <td>{question.answer}</td>
                                                                                    <td>
                                                                                        <button className="btn btn-primary view_icon mt-1" type="button" onClick={() => {
                                                                                            setVisibleSolution(!visibleSolution)
                                                                                            setModalData(question.solution)
                                                                                        }}><i class="fa fa-eye" ></i></button>
                                                                                    </td>
                                                                                </tr>
                                                                            )
                                                                        })
                                                                        :
                                                                        (<tr>
                                                                            <th colspan={"100%"} style={{ textAlign: 'center' }}>No Questions Available</th>
                                                                        </tr>)
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>}

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default CompetitiveUploadQuestionBank;